import type { PresentationOptionV2 } from 'paintscout'
import { hasBlockType } from './hasBlockType'

export function hasTermsBlock(presentation: PresentationOptionV2): boolean {
  return hasBlockType(presentation, 'terms')
}
